import React from "react";
import { useParams } from "react-router-dom";
import Container from "reactstrap/lib/Container";
import { Col } from "ComponentsUI/Styles/Grid";
import Row from "reactstrap/lib/Row";
import withStyles from "react-jss";
import classNames from "classnames";
import useRegionContacts from "./useRegionContacts";
import PartnersContainer from "Containers/PartnersContainer";
import { Helmet } from "react-helmet-async";
import { generateUrl } from "Services/withDefaultParams";
import configRouters from "Configs/routes";
import { inject } from "mobx-react";
import { isMoscowSiteCode, isMainSiteCode, isPiterSiteCode } from "Utils/siteConfig";
import YandexWidgetReviews from "Containers/YandexWidgetReviews";
import { Redirect404 } from "ComponentsUI/Redirects";

const TextInfo = ({ title, description, contact, insinePhone, classes, isMailLink }) => {
	return (
		<div className={classes.infoRoot}>
			<div className={classes.infoTitle}>{title}</div>
			<div className={classes.infoDescription}>{description}</div>
			{contact && (
				<a
					aria-label={isMailLink ? "mail" : "call"}
					href={`${isMailLink ? "mailto" : "tel"}:${insinePhone || contact}`}
					className={classes.infoContact}
				>
					{contact}
				</a>
			)}
		</div>
	);
};

const TextBlockInfo = ({ classes, type, days, time, dayOf, requisites }) => {
	return (
		<div
			className={classNames(classes.textBlockRoot, {
				[classes.requisites]: requisites,
			})}
		>
			<div
				className={classNames(classes.textBlockType, {
					[classes.requisites]: requisites,
				})}
			>
				{type}
			</div>
			{days && (
				<div
					className={classNames(classes.textBlock, {
						[classes.requisites]: requisites,
					})}
				>
					{days}
				</div>
			)}
			{time && (
				<div
					className={classNames(classes.textBlock, {
						[classes.requisites]: requisites,
					})}
				>
					{time}
				</div>
			)}
			{dayOf && (
				<div
					className={classNames(classes.textBlock, {
						[classes.requisites]: requisites,
					})}
				>
					{dayOf}
				</div>
			)}
		</div>
	);
};

const AddressInfo = ({
	classes,
	office_address,
	shema_proezda,
	passage,
	post_address,
	additional_contacts,
	additional_address,
	data,
	siteCode,
}) => (
	<>
		<Row>
			<Col className={classes.contactsInfoTitle}>Схема проезда</Col>
		</Row>
		<Row
			className={classNames(classes.rowSpacing, {
				[classes.withImg]: true,
			})}
		>
			<Col lg={12} md={12} sm={12} xs={12}>
				<div
					dangerouslySetInnerHTML={{
						__html: shema_proezda,
					}}
				/>
			</Col>
			{!isMainSiteCode(siteCode) && (
				<Col lg={12} md={12} sm={12} xs={12} className={classes.colSpacing}>
					<TextInfo title={"Как добраться?"} description={passage} classes={classes} />
				</Col>
			)}
		</Row>
		{!isMainSiteCode(data.siteConfig.code) && (
			<Row className={classes.rowSpacing}>
				<Col lg={6} md={6} sm={12} xs={12}>
					<TextInfo title={"Адрес офиса компании"} description={office_address} classes={classes} />
				</Col>
				{post_address && (
					<Col lg={6} md={6} sm={12} xs={12}>
						<TextInfo title={"Почтовый адрес"} description={post_address} classes={classes} />
					</Col>
				)}
			</Row>
		)}
		<Row className={classes.rowSpacing}>
			{additional_contacts && (
				<Col lg={6} md={6} sm={12} xs={12}>
					<TextInfo
						title={isMainSiteCode(siteCode) ? "" : "Дополнительные контакты"}
						description={additional_contacts.map((i) => (
							<div key={i}>{i}</div>
						))}
						classes={classes}
					/>
				</Col>
			)}
			{Boolean(additional_address?.length) && (
				<Col lg={6} md={6} sm={12} xs={12}>
					<TextInfo
						title={"Дополнительные адреса"}
						description={additional_address.map((i) => (
							<div key={i}>{i}</div>
						))}
						classes={classes}
					/>
				</Col>
			)}
		</Row>
	</>
);
const Contacts = (props) => {
	const routeParams = useParams();

	if (
		routeParams?.regionUrl &&
		routeParams?.regionUrl !== props.ApplicationModel?.currentRegion?.url
	) {
		return <Redirect404 message404={`Несовпадение regionUrl: ${routeParams?.regionUrl}`} />;
	}

	const { loading, error, data } = useRegionContacts();
	if (loading) return null;

	const contacts = data.siteConfig.contacts;
	let size = isMainSiteCode(data.siteConfig.code) ? 12 : 6;
	let insinePhone = contacts.contact_phone.replace(/[^+\d]/g, "");

	const canonical = () => {
		const {
			ApplicationModel: { siteConfig },
		} = props;

		const location = generateUrl(configRouters.Contacts.route, props.match.params);

		return (
			<Helmet>
				<link
					rel="canonical"
					href={`${siteConfig.ssl === true ? `https` : "http"}://${
						siteConfig.domain_name_full
					}${location}`}
				/>
			</Helmet>
		);
	};

	return (
		<>
			{canonical()}
			<Container>
				<Row className={props.classes.rowSpacing}>
					<Col lg={4} md={4} sm={12} xs={12}>
						<TextInfo
							title={"Сотрудничество и реклама"}
							description={"Рассмотрим предложения о сотрудничестве и рекламе"}
							contact={contacts.email_for_partners}
							classes={props.classes}
							isMailLink
						/>
					</Col>
					{isMainSiteCode(data.siteConfig.code) && (
						<Col lg={4} md={4} sm={12} xs={12}>
							<TextInfo
								title={"Для резюме"}
								description={"Резюме с рассказом о себе высылайте нам "}
								contact={"hr@101internet.ru"}
								classes={props.classes}
								isMailLink
							/>
						</Col>
					)}
					<Col lg={4} md={4} sm={12} xs={12}>
						<TextInfo
							title={"Контактный центр"}
							description={"Единый телефон контактного центра"}
							contact={contacts.contact_phone}
							insinePhone={insinePhone}
							classes={props.classes}
						/>
					</Col>
				</Row>
				<AddressInfo
					classes={props.classes}
					{...contacts}
					data={data}
					siteCode={data.siteConfig.code}
				/>
				<Row className={props.classes.rowSpacing}>
					<Col lg={size} md={size} sm={12} xs={12}>
						<TextInfo
							title={"Время работы"}
							description={
								<>
									<TextBlockInfo
										classes={props.classes}
										type={"Консультация физических лиц"}
										days={"Понедельник - воскресенье"}
										time={"Круглосуточно"}
									/>
									<TextBlockInfo
										classes={props.classes}
										type={"Консультация юридических лиц"}
										days={"Понедельник - пятница"}
										time={"09:00 - 18:00 (МСК)"}
										dayOf={"Суббота, воскресенье: выходной"}
									/>
									<TextBlockInfo
										classes={props.classes}
										type={"Прием заявок через сайт"}
										days={"круглосуточно"}
									/>
								</>
							}
							classes={props.classes}
						/>
					</Col>
					{isMainSiteCode(data.siteConfig.code) && (
						<>
							<Col lg={6} md={6} sm={12} xs={12}>
								<TextInfo
									title={'Реквизиты ООО "ИНТЕРНЕТ ПРОМОУШЕН"'}
									description={
										<>
											<TextBlockInfo
												requisites
												classes={props.classes}
												type={`ООО "ИНТЕРНЕТ ПРОМОУШЕН"`}
											/>
											<TextBlockInfo
												requisites
												classes={props.classes}
												type={
													"Юридический адрес: 390005, Рязанская область, город Рязань, ул. Типанова, д. 21, кв. 109"
												}
											/>
											<TextBlockInfo
												requisites
												classes={props.classes}
												type={"ОГРН: 1226200005899"}
											/>
											<TextBlockInfo requisites classes={props.classes} type={"ИНН: 6234200687"} />
											<TextBlockInfo
												requisites
												classes={props.classes}
												type={
													"Адрес электронной почты для направления заявления о нарушении авторских и/или смежных прав welcome@promotioninternet.ru"
												}
											/>
											<TextBlockInfo
												requisites
												classes={props.classes}
												type={"Генеральный директор: Павлова Александра Леонардовна"}
											/>
										</>
									}
									classes={props.classes}
								/>
							</Col>
						</>
					)}
					{isMoscowSiteCode(data.siteConfig.code) && (
						<Col lg={6} md={6} sm={12} xs={12}>
							<TextInfo
								title={"Реквизиты"}
								description={
									<>
										<TextBlockInfo
											requisites
											classes={props.classes}
											type={'ООО "Онлайн Сервисы"'}
										/>
										<TextBlockInfo requisites classes={props.classes} type={"ИНН: 6234184650"} />
										<TextBlockInfo
											requisites
											classes={props.classes}
											type={"ОГРНИП: 1196234008915"}
										/>
										<TextBlockInfo requisites classes={props.classes} type={"ОКПО 40189177"} />
										<TextBlockInfo
											requisites
											classes={props.classes}
											type={"Номер счёта: 40702810353000008914"}
										/>
										<TextBlockInfo requisites classes={props.classes} type={"Банк: ПАО Сбербанк"} />
										<TextBlockInfo requisites classes={props.classes} type={"БИК: 046126614"} />
										<TextBlockInfo
											requisites
											classes={props.classes}
											type={"Кор. счёт: 30101810500000000614"}
										/>
									</>
								}
								classes={props.classes}
							/>
						</Col>
					)}
					{isPiterSiteCode(data.siteConfig.code) && (
						<Col lg={6} md={6} sm={12} xs={12}>
							<TextInfo
								title={"Реквизиты"}
								description={
									<>
										<TextBlockInfo
											requisites
											classes={props.classes}
											type={"ИП Рубцов Дмитрий Сергеевич"}
										/>
										<TextBlockInfo requisites classes={props.classes} type={"ИНН: 623017935007"} />
										<TextBlockInfo
											requisites
											classes={props.classes}
											type={"ОГРНИП: 319623400010678"}
										/>
										<TextBlockInfo requisites classes={props.classes} type={"ОКПО: 0147808480"} />
										<TextBlockInfo
											requisites
											classes={props.classes}
											type={"Номер счёта: 40802810153000000876"}
										/>
										<TextBlockInfo
											requisites
											classes={props.classes}
											type={"Банк: РЯЗАНСКОЕ ОТДЕЛЕНИЕ N 8606 ПАО СБЕРБАНК"}
										/>
										<TextBlockInfo requisites classes={props.classes} type={"БИК: 046126614"} />
										<TextBlockInfo
											requisites
											classes={props.classes}
											type={"Кор. счёт: 30101810500000000614"}
										/>
									</>
								}
								classes={props.classes}
							/>
						</Col>
					)}
				</Row>
				<Row className={props.classes.rowSpacing}>
					<Col lg={12} md={12} sm={12} xs={12}>
						<PartnersContainer />
					</Col>
				</Row>
				<YandexWidgetReviews contacts />
			</Container>
		</>
	);
};

const styles = (theme) => ({
	infoRoot: {
		fontFamily: theme.fonts.medium,
	},
	title: {
		fontStyle: "normal",
		fontWeight: "600",
		fontSize: "21px",
		lineHeight: "18px",
		letterSpacing: "1px",
		color: theme.palette.colors.darkSlateBlue2,
		margin: "13px 0 26px 0",
		position: "relative",
		"&:after": {
			left: "0",
			width: "79px",
			bottom: "-9px",
			height: "2px",
			content: "''",
			position: "absolute",
			backgroundColor: "#5812fe",
		},
	},
	infoTitle: {
		fontStyle: "normal",
		fontWeight: "600",
		fontSize: "21px",
		lineHeight: "18px",
		letterSpacing: "1px",
		color: theme.palette.colors.darkSlateBlue2,
	},
	infoDescription: {
		fontStyle: "normal",
		fontWeight: "normal",
		fontSize: "16px",
		lineHeight: "18px",
		letterSpacing: "1px",
		color: theme.palette.colors.oneMoreGrey,
		margin: "13px 0 26px 0",
	},
	infoContact: {
		fontStyle: "normal",
		fontWeight: "600",
		fontSize: "21px",
		lineHeight: "18px",
		letterSpacing: "1px",
		color: theme.palette.colors.purplishBlue,
	},
	rowSpacing: {
		marginBottom: "30px",
	},
	colSpacing: {
		marginTop: "40px",
	},
	contactsInfoTitle: {
		fontSize: "21px",
		fontStyle: "normal",
		fontWeight: "600",
		lineHeight: "36px",
		letterSpacing: "0px",
		textAlign: "center",
		color: theme.palette.colors.darkSlateBlue2,
	},
	withImg: {
		backgroundColor: "#D2CEE0",
		padding: "25px",
	},
	pic: {
		width: "100%",
	},
	textBlockRoot: {
		marginTop: "13px",
	},
	textBlockType: {
		fontSize: "16px",
		color: theme.palette.colors.darkSlateBlue2,
	},
	requisites: {
		fontSize: "14px",
		fontWeight: "normal",
	},
	[`@media (max-width: ${theme.media.md})`]: {
		infoRoot: {
			marginBottom: "25px",
		},
		infoTitle: {
			fontSize: "16px",
		},
		infoDescription: {
			fontSize: "14px",
			margin: "10px 0",
		},
		infoContact: {
			fontSize: "16px",
		},
		contactsInfoTitle: {
			fontSize: "16px",
		},
		rowSpacing: {
			marginBottom: "20px",
		},
		withImg: {
			padding: "10px",
		},
		colSpacing: {
			marginTop: "20px",
		},
	},
});

export default withStyles(styles)(inject("ApplicationModel")(Contacts));
